import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaLocationExposures({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Type)}</th>
                    <th>{translator(messages.City)}</th>
                    <th>{translator(messages.State)}</th>
                    <th>{translator(messages.Address)}</th>
                    <th>{translator(messages.Excluded)}</th>
                </tr>
            </thead>
        );
    }

    const getExcluded = (excluded) => {
        if(excluded){
            return translator(messages.Yes);
        }
        return translator(messages.No);
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.LocationExposures)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((exposure) => {
                            return (
                                <>
                                    <tr>
                                        <td><strong>{exposure.type}</strong></td>
                                        <td><strong>{exposure.city}</strong></td>
                                        <td>{exposure.state}</td>
                                        <td>{exposure.address}</td>
                                        <td>{getExcluded(exposure.excluded)}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaLocationExposures.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLUmbrellaLocationExposures.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaLocationExposures;
